import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {useDispatch} from 'react-redux';
import {Form, Input, Button, Upload, message, Switch, DatePicker} from 'antd';
import {UploadOutlined} from '@ant-design/icons';
import TextArea from 'antd/lib/input/TextArea';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import moment from 'moment';
import {addBlogs} from 'redux/actions/Blog';

const formItemLayout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 14,
  },
};
function AddBlog({closeModel}) {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [checked, setChecked] = useState(false);
  const [content, setContent] = useState('');
  const [contentTouched, setContentTouched] = useState(false);
  const [showHtmlSource, setShowHtmlSource] = useState(false);

  // Trigger validation when content changes (only after user has touched the field)
  useEffect(() => {
    if (contentTouched) {
      form.validateFields(['Content']).catch(() => {
        // Ignore validation errors, just trigger the validation
      });
    }
  }, [content, contentTouched, form]);

  const onFinish = (values) => {
    // Validate content before submission
    if (!content || content.trim() === '' || content === '<p><br></p>') {
      message.error('Content is required');
      return;
    }

    let body = {
      ...values,
      BannerImage: values.BannerImage?.fileList[0]?.originFileObj,
      Content: content,
    };
    console.log('body', body);
    const formData = new FormData();

    formData.append('Title', body.Title);
    formData.append('ShortDescription', body.ShortDescription || '');
    formData.append('Content', body.Content);
    formData.append('Author', body.Author || '');
    formData.append(
      'PublishedOn',
      body.PublishedOn ? moment(body.PublishedOn).format('MM/DD/YYYY') : '',
    );
    formData.append('order', body.order || '');
    formData.append('isActive', checked);

    if (body?.BannerImage) {
      formData.append(
        'BannerImage',
        body?.BannerImage,
        `banner-${Date.now()}.png`,
      );
    }
    dispatch(addBlogs(formData));
    closeModel();
    form.resetFields();
    setContent('');
    setContentTouched(false);
  };

  const ImageProps = {
    name: 'file',
    multiple: false,
    maxCount: 1,

    customRequest: (e) => {
      e.onSuccess({message: 'Done'});
    },
    beforeUpload: (file) => {
      const isPNG = ['image/png', 'image/jpg', 'image/jpeg'].includes(
        file.type,
      );

      if (!isPNG) {
        message.error(`${file.name} is not a image file`);
      }

      const inSize = file.size < 5000000;

      if (!inSize) {
        message.error(`${file.name} is larger than 5 MB`);
      }

      return (isPNG && inSize) || Upload.LIST_IGNORE;
    },

    onChange(info) {
      const {status} = info.file;

      if (status === 'done') {
        message.success(`${info.file.name} file added successfully.`);
      } else if (status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    },

    onDrop(e) {
      e.preventDefault();
    },
  };

  const quillModules = {
    toolbar: [
      [{header: [1, 2, 3, 4, 5, 6, false]}],
      ['bold', 'italic', 'underline', 'strike'],
      [{color: []}, {background: []}],
      [{list: 'ordered'}, {list: 'bullet'}],
      [{indent: '-1'}, {indent: '+1'}],
      [{align: []}],
      ['link', 'image', 'video'],
      ['blockquote', 'code-block'],
      ['clean'],
    ],
  };

  const quillFormats = [
    'header',
    'font',
    'size',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
    'video',
    'color',
    'background',
    'align',
    'code-block',
  ];

  return (
    <Form
      form={form}
      className='edit-customer-form'
      name='validate_other'
      {...formItemLayout}
      onFinish={onFinish}
      initialValues={{
        Title: '',
        ShortDescription: '',
        Author: '',
        PublishedOn: null,
        Order: 1,
      }}>
      <Form.Item
        name='Title'
        label='Title'
        rules={[{required: true, message: 'Title is required'}]}>
        <Input placeholder='Enter blog title' />
      </Form.Item>

      <Form.Item
        name='ShortDescription'
        label='Short Description'
        rules={[{required: false}]}>
        <TextArea placeholder='Enter short description of the blog' rows={3} />
      </Form.Item>

      <Form.Item
        name='Content'
        label='Content'
        rules={[
          {
            validator: (_, value) => {
              // Only validate if the field has been touched
              if (contentTouched) {
                if (
                  !content ||
                  content.trim() === '' ||
                  content === '<p><br></p>'
                ) {
                  return Promise.reject(new Error('Content is required'));
                }
              }
              return Promise.resolve();
            },
          },
        ]}>
        <div style={{marginBottom: '20px'}}>
          {/* <div style={{marginBottom: '10px'}}>
            <Button
              size='small'
              onClick={() => setShowHtmlSource(!showHtmlSource)}
              style={{marginBottom: '10px'}}>
              {showHtmlSource ? 'Rich Text Editor' : 'HTML Source'}
            </Button>
          </div> */}
          {/* {showHtmlSource ? (
            <TextArea
              value={content}
              onChange={(e) => {
                setContent(e.target.value);
                setContentTouched(true);
              }}
              placeholder='Enter HTML content here...'
              rows={12}
              style={{fontFamily: 'monospace'}}
            />
          ) : ( */}
          <div style={{height: '300px'}}>
            <ReactQuill
              theme='snow'
              value={content}
              onChange={(value) => {
                setContent(value);
                setContentTouched(true);
              }}
              modules={quillModules}
              formats={quillFormats}
              style={{height: '250px'}}
            />
          </div>
          {/* )} */}
        </div>
      </Form.Item>

      <Form.Item name='Author' label='Author' rules={[{required: false}]}>
        <Input placeholder='Enter author name' />
      </Form.Item>

      <Form.Item
        name='PublishedOn'
        label='Published On'
        rules={[{required: false}]}>
        <DatePicker
          format='MM/DD/YYYY'
          placeholder='Select publish date'
          style={{width: '100%'}}
        />
      </Form.Item>

      <Form.Item
        name='order'
        label='Order'
        rules={[
          {
            validator: (_, value) => {
              if (value && value <= 0) {
                return Promise.reject(
                  new Error('Order must be greater than 0'),
                );
              }
              return Promise.resolve();
            },
          },
        ]}>
        <Input type='number' placeholder='Enter display order' />
      </Form.Item>

      <Form.Item name='isActive' label='Status' valuePropName='checked'>
        <Switch
          checked={checked}
          onChange={() => setChecked(!checked)}
          checkedChildren='Active'
          unCheckedChildren='Inactive'
        />
      </Form.Item>

      <Form.Item
        name='BannerImage'
        label='Banner Image'
        rules={[{required: false}]}>
        <Upload {...ImageProps}>
          <Button icon={<UploadOutlined />}>Choose Banner Image</Button>
        </Upload>
      </Form.Item>

      <Form.Item
        wrapperCol={{
          span: 12,
          offset: 10,
        }}>
        <Button type='primary' htmlType='submit'>
          Save Blog
        </Button>
      </Form.Item>
    </Form>
  );
}

export default AddBlog;

AddBlog.propTypes = {
  closeModel: PropTypes.func,
};
